import React from 'react';
import PropTypes from 'prop-types';

const DoneLogo = ({ size, flat }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {flat ? (
      <rect width="80" height="80" rx="28" fill="white" fillOpacity="0.4" />
    ) : (
      <rect
        width="80"
        height="80"
        rx="28"
        fill="url(#done_logo_linear_1181_9834)"
      />
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.2335 26.437C58.4452 27.567 58.5115 29.4653 57.3816 30.6771L35.5961 54.0393C34.2402 55.4934 31.9622 55.5729 30.5081 54.217L22.4562 46.7085C21.2444 45.5785 21.1781 43.6802 22.3081 42.4684C23.4381 41.2567 25.3364 41.1904 26.5482 42.3203L32.8448 48.1921L52.9934 26.5851C54.1234 25.3734 56.0217 25.3071 57.2335 26.437Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="done_logo_linear_1181_9834"
        x1="30.3226"
        y1="-2.72904e-08"
        x2="53.2258"
        y2="90.3226"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00BFA5" />
        <stop offset="1" stopColor="#B9F6CA" />
      </linearGradient>
    </defs>
  </svg>
);

DoneLogo.propTypes = {
  flat: PropTypes.bool,
  size: PropTypes.number, // White semi transparent background instead of a gradient background
};

DoneLogo.defaultProps = {
  flat: false,
  size: 80,
};

export default DoneLogo;
